import { AttributeType, ColumnDescriptionDc } from "@evergis/api";
import { DEFAULT_ID_ATTRIBUTE_NAME } from "../../constants";
import { getResourceName } from "../../../utils/resourceName";
import { getFieldTypeValue } from "../attributes/fieldTypes";
import { ImportAttribute } from "../../../components/Dialogs/Import/types";

export function addSrid(
  columns: ColumnDescriptionDc[],
  geometryAttribute: string,
  srid: number,
): ColumnDescriptionDc[] {
  return columns.map(attribute => {
    if (attribute.name === geometryAttribute) {
      return {
        ...attribute,
        srid,
      };
    }

    return attribute;
  });
}

export const DEFAULT_ID_ATTRIBUTE: ImportAttribute = {
  name: DEFAULT_ID_ATTRIBUTE_NAME,
  type: AttributeType.Int64,
};

export function attributesToTable(
  attributes: ImportAttribute[],
  idAttribute: string,
  geometryAttribute: string,
  srid: number,
): { name: string; columns: ColumnDescriptionDc[] } {
  const columns = attributes
    .filter(({ disabled, expression, sysAttribute }) => (!disabled && !expression) || sysAttribute)
    .map(({ id, disabled, type, ...rest }) => ({
      ...rest,
      type: getFieldTypeValue(type) || type,
      autoincrement: rest.name === idAttribute,
    }));

  const attributesWithId =
    idAttribute || columns.some(({ name }) => name === DEFAULT_ID_ATTRIBUTE_NAME)
      ? columns
      : [DEFAULT_ID_ATTRIBUTE, ...columns];

  return {
    name: getResourceName(),
    columns: addSrid(attributesWithId as ColumnDescriptionDc[], geometryAttribute, srid),
  };
}
